// extracted by mini-css-extract-plugin
module.exports = {"card":"clinical-portal-3__CallPlayer__card","canvas":"clinical-portal-3__CallPlayer__canvas","errorBoundary":"clinical-portal-3__CallPlayer__errorBoundary"};